import { inject, injectable } from "inversify";
import { ICPLFundHeaderClient, IntSelectModel } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IFundHeaderService {
  getSelectModels(): Promise<IntSelectModel[]>;
}

@injectable()
export class FundHeaderService implements IFundHeaderService {
  @inject(SERVICE_TYPES.CPLFundHeaderClient) cplFundHeaderClient!: ICPLFundHeaderClient;

  async getSelectModels(): Promise<IntSelectModel[]> {
    return this.cplFundHeaderClient.getSelectModels();
  }
}
